import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/700.css";
import "@fontsource/cardo/400.css";
import "@fontsource/cardo/700.css";
import React from "react";
import { WhitelabelProvider } from "./src/context/WhitelabelContext";
import { FeatureProvider } from "./src/context/FeatureContext";
import { AuthProvider } from "./src/context/AuthContext";
import AppContent from "./AppContent";

export default function App() {
  return (
    <AuthProvider>
      <WhitelabelProvider>
        <FeatureProvider>
          <AppContent />
        </FeatureProvider>
      </WhitelabelProvider>
    </AuthProvider>
  );
}